import React from "react";
import { Button, Col } from "rsuite";

export const Card = ({ post_title, image, price, url }) => (
  <Col xs={24} sm={12} md={6}>
    <div className="card">
      <a className="card-body" href={url}>
        <div
          className="card-image"
          style={{ backgroundImage: `url(${image})` }}
        ></div>
        <div className="card-name">{post_title}</div>
        <div
          className="card-price"
          dangerouslySetInnerHTML={{ __html: price }}
        />
        <Button>Read More</Button>
      </a>
    </div>
  </Col>
);
